
import { Link, NavLink } from 'react-router-dom'
import { FaMoon, FaSun } from 'react-icons/fa'
import { NavItems } from '../../constants/mockdata'
import { residentPwaLink } from '../../constants'

type MobileNavLinksProps = {
  toggleMobileMenu: () => void
  isDarkMode: boolean
  toggleDarkMode: (force?: boolean) => void
}

const MobileNavLinks = ({
  toggleMobileMenu,
  isDarkMode,
  toggleDarkMode,
}: MobileNavLinksProps) => {
  return (
    <ul className="space-y-4 mb-28">
      {NavItems.map((link) => (
        <li className="border-b pb-5 text-sm dark:text-white" key={link.path}>
          <NavLink
            to={link.path}
            onClick={toggleMobileMenu}
            style={({ isActive }) => ({ fontWeight: isActive ? 'bold' : '' })}
          >
            {link.label}
          </NavLink>
        </li>
      ))}
      <li>
        <a
          href={residentPwaLink()}
          className="block text-black dark:text-white font-normal text-start text-sm border-b w-full pb-5"
        >
          For residents
        </a>
      </li>
      <li>
        <Link to="/waitlist">
          <button className="text-black dark:text-white font-normal text-start text-sm border-b w-full pb-5">
            Join Waitlist
          </button>
        </Link>
      </li>
      <li>
        <Link to="/auth/register">
          <button className="text-black dark:text-white font-normal text-start text-sm border-b w-full pb-5">
            Get Started
          </button>
        </Link>
      </li>
      <li>
        <button
          onClick={() => toggleDarkMode()}
          aria-label="Toggle dark mode"
          className="p-2 rounded-md text-black dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800"
        >
          {isDarkMode ? <FaMoon className="h-5 w-5" /> : <FaSun className="h-5 w-5" />}
        </button>
      </li>
    </ul>
  )
}

export default MobileNavLinks
